import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'

import { ICertificate ,ICourseCertificate, IMyCertificate } from 'models/certificate.model'
import { ExternalCourseCertificate } from '../../models/externalCourseCertificate.model';


export const CERTIFICATES_ADMINISTRATION_SEARCH = 'CERTIFICATES_ADMINISTRATION_SEARCH'
export const CERTIFICATES_ADMINISTRATION_SEARCH_SUCCESS = 'CERTIFICATES_ADMINISTRATION_SEARCH_SUCCESS'
export const CERTIFICATES_ADMINISTRATION_LIST = 'CERTIFICATES_ADMINISTRATION_LIST'
export const CERTIFICATES_ADMINISTRATION_LIST_SUCCESS = 'CERTIFICATES_ADMINISTRATION_LIST_SUCCESS'
export const GET_ADMIN_CERTIFICATE = 'GET_ADMIN_CERTIFICATE'
export const GET_ADMIN_CERTIFICATE_SUCCESS = 'GET_ADMIN_CERTIFICATE_SUCCESS'
export const DESTROY_CERTIFICATE = 'DESTROY_CERTIFICATE'
export const CREATE_CERTIFICATE = 'CREATE_CERTIFICATE'
export const UPDATE_CERTIFICATE = 'UPDATE_CERTIFICATE'
export const CERTIFICATE_COURSES_LIST = 'CERTIFICATE_COURSES_LIST'
export const CERTIFICATE_COURSES_LIST_SUCCESS = 'CERTIFICATE_COURSES_LIST_SUCCESS'
export const GET_MY_CERTIFICATES = 'GET_MY_CERTIFICATES'
export const GET_MY_CERTIFICATES_SUCCESS = 'GET_MY_CERTIFICATES_SUCCESS'
export const GET_MY_EXTERNAL_COURSE_CERTIFICATES = 'GET_MY_EXTERNAL_COURSE_CERTIFICATES'
export const GET_MY_EXTERNAL_COURSE_CERTIFICATES_SUCCESS = 'GET_MY_EXTERNAL_COURSE_CERTIFICATES_SUCCESS'
export const GET_MY_CERTIFICATE = 'GET_MY_CERTIFICATE'
export const GET_MY_CERTIFICATE_SUCCESS = 'GET_MY_CERTIFICATE_SUCCESS'

export const Actions = {
  certificateAdministrationListSuccess: (data: ICertificate[]) => createAction(CERTIFICATES_ADMINISTRATION_LIST_SUCCESS, { data }),
  getCertificateSuccess: (data: ICertificate) => createAction(GET_ADMIN_CERTIFICATE_SUCCESS, data),
  getCertificate: (certificateId: number) => createAction(GET_ADMIN_CERTIFICATE, certificateId),
  destroyCertificate: (certificateId: number) => createAction(DESTROY_CERTIFICATE, certificateId),
  createCertificate: (data: ICertificate) => createAction(CREATE_CERTIFICATE, data),
  updateCertificate: (data: ICertificate, certificateId: number) => createAction(UPDATE_CERTIFICATE, { data, certificateId }),
  certificateCoursesAdministrationList: (certificateType: number, certificateId?: number) => createAction(CERTIFICATE_COURSES_LIST, { certificateType, certificateId }),
  certificateCoursesAdministrationListSuccess: (data: ICourseCertificate[]) => createAction(CERTIFICATE_COURSES_LIST_SUCCESS, { data }),
  myCertificateListSuccess: (data: IMyCertificate[]) => createAction(GET_MY_CERTIFICATES_SUCCESS, { data }),
  getMyExternalCourseCertificates: () => createAction(GET_MY_EXTERNAL_COURSE_CERTIFICATES),
  setMyExternalCourseCertificatesListSuccess: (data: ExternalCourseCertificate[]) => createAction(GET_MY_EXTERNAL_COURSE_CERTIFICATES_SUCCESS, { data }),
  getMyCertificateSuccess: (data: IMyCertificate) => createAction(GET_MY_CERTIFICATE_SUCCESS, data),
  getMyCertificate: (certificateId: number) => createAction(GET_MY_CERTIFICATE, certificateId),
}

export type Actions = ActionsUnion<typeof Actions>